(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["yoyoo-ddr"] = factory();
	else
		root["yoyoo-ddr"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 